import { Tasks } from '../utils/types';
import { translateStatus } from '../utils/emails/askers/statusEmails/statusHelpers';

export const generateTaskNotificationEmail = (task: Tasks): string => {
  const taskyColors = {
    primary: '#7E22CE', // Purple
    secondary: '#F3E8FF', // Light Purple
    text: '#1F2937', // Dark Gray
  };

  return `
    <html>
      <body style="font-family: Arial, sans-serif; margin: 0; padding: 0; background-color: ${
        taskyColors.secondary
      }; color: ${taskyColors.text};">
        <div style="max-width: 600px; margin: 0 auto; background-color: white; padding: 20px; border-radius: 8px;">
          <h1 style="text-align: center; color: ${
            taskyColors.primary
          }; margin-top: 20px;">Actualización de tu Task</h1>
          <h3 style="text-align: center; color: ${taskyColors.text};">Hola ${
    task.name
  }, tu task ha sido actualizada.</h3>

          <div style="background-color: ${
            taskyColors.secondary
          }; padding: 15px; border-radius: 8px; text-align: center; margin: 20px 0;">
            <h2 style="font-size: 18px; color: ${
              taskyColors.primary
            }; margin-bottom: 10px;">Estado actual:</h2>
            <div style="font-size: 24px; font-weight: bold; color: ${
              taskyColors.primary
            };">
              ${translateStatus(task.status).toUpperCase()}
            </div>
          </div>

          <div style="margin-top: 20px; border-top: 1px solid ${
            taskyColors.secondary
          }; padding-top: 20px;">
            <h3 style="color: ${
              taskyColors.primary
            }; font-size: 18px;">Detalles de la tarea:</h3>
            <p><strong>Descripción:</strong> ${task.description}</p>
            <p><strong>Categoría:</strong> ${task.category}</p>
            <p><strong>Precio:</strong> ${task.price}</p>
          </div>

          <div style="margin-top: 20px; font-size: 14px; color: ${
            taskyColors.text
          }; text-align: center;">
            <p>Si tienes alguna pregunta, contáctanos.</p>
            <p>Equipo de Tasky</p>
          </div>
        </div>
      </body>
    </html>
  `;
};
